<div
  *ngIf="isVisible"
  class="setup-banner"
  [ngClass]="[positionClass]"
  [class.setup-banner--animating-out]="isAnimating"
  [class.setup-banner--warning]="config.variant === 'warning'"
  [class.setup-banner--error]="config.variant === 'error'"
>
  <div class="setup-banner__icon">
    <g99-icon-btn
      [icon]="infoIcon"
      [height]="16"
      [width]="16"
      [fillColor]="'#fff'"
    />
  </div>

  <div class="setup-banner__content">
    <span class="setup-banner__text">
      {{ config.message }}
      <a
        *ngIf="config.linkText"
        href="#"
        class="setup-banner__link"
        (click)="handleLinkClick($event)"
      >
        {{ config.linkText }}
      </a>

      <ng-container *ngIf="config.externalLinkText">
        {{ config.externalLinkUrl ? '' : '.' }}
        <a
          *ngIf="config.externalLinkUrl"
          class="setup-banner__link"
          target="_blank"
          [href]="config.externalLinkUrl"
        >
          {{ config.externalLinkText }} </a
        >.
      </ng-container>
    </span>
  </div>

  <span class="setup-banner__close">
    <g99-icon-btn
      [icon]="closeIcon"
      [color]="'#fff'"
      (iconClick)="closeBanner()"
    />
  </span>
</div>
